import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueListDTO from '../models/generic/KeyValueListDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';

export class StateApiController {
    // get: State/GetCountries
    public RouteGetCountries = () => `State/GetCountries`;
    public getCountries(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueListDTO>> {
        let url = this.RouteGetCountries();
        return HttpApi.RestRequest<any, KeyValueListDTO>(null, 'get', url, requestOptions);
    }
    // get: State/GetStates
    public RouteGetAllStates = () => `State/GetStates`;
    public getAllStates(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllStates();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: State/GetStatesByCountry/${countryId}/${includeClientStates}
    public RouteGetStatesByCountry = (countryId: number, includeClientStates: boolean) => `State/GetStatesByCountry/${countryId}/${includeClientStates}`;
    public getStatesByCountry(countryId: number, includeClientStates: boolean, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueListDTO>> {
        let url = this.RouteGetStatesByCountry(countryId, includeClientStates);
        return HttpApi.RestRequest<any, KeyValueListDTO>(null, 'get', url, requestOptions);
    }
}
var service = new StateApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/StateApiController.ts